export default {
  zh: {
    creation: "创建公司",
    establish: "开始你的申请吧",
    messageTitle: "申请人信息填写",
    applicant: "申请人",
    mobile: "手机号",
    email: "邮箱",
    residentialAddress: "住址",
    applicantRole: "申请人角色",
    role: "角色",
    locationTitle: "拟设公司/基金所在地",
    country: "国家",
    comboTitle: "选择套餐",
    businessType: "业务类型",
    query01: "[新加坡] 新设立公司 - 优惠套餐",
    query02: "新加坡设立公司的常见问题及回复汇总",
    query03: "[新加坡]公司费用表 – 公司秘书服务|会计服务|报税服务",
    remarkTitle: "备注:",
    crowd: "适用人群：",
    comboInclude: "套餐包含：",
    priceInclude: "第三方费用：",
    otherExpenses: "其他费用：",
    year: "年",
    service: "需要灵活选择服务的客户",
    select: "选择服务",
    custom: "自定义套餐 - 公司设立",
    customTransfer: "自定义套餐 - 服务转移",
    createApplication: "创建申请",
    total: "总价: ",
    warn: "(谨此提醒：我们的名义董事服务、公司注册地址服务不单独提供，该两项服务须跟公司秘书服务一起提供。)",
    copySource: "拷贝自",
    copySourceExplain: "为节省你的时间，若申请人曾通过本系统申请过该公司/基金，可通过该选项选择该公司/基金名称、拷贝公司/基金相关的信息至本申请表中。",
    operatingType: "操作类型",
    renewService: "续约服务",
    increaseService: "增加服务",
    other: "新申请",
    entityType: "主体类型",
    promotion: "促销编号",
  },
  en: {
    creation: "Creation",
    establish: "Start your application",
    messageTitle: "Applicant information",
    applicant: "Applicant name",
    mobile: "Mobile",
    email: "Email",
    residentialAddress: "Residential Address",
    applicantRole: "Applicant role",
    role: "Role",
    locationTitle: "Location of the proposed company/fund",
    country: "Country",
    comboTitle: "Choice of service(s)",
    businessType: "Business type",
    query01: "[SG] Company set up promotion packages",
    query02: "[Q] Summary of FAQs and replies on setting up companies in Singapore",
    query03: "[SG] Our fees for the services provided",
    remarkTitle: "Note:",
    crowd: "Exclusive for:",
    comboInclude: "Package includes:",
    priceInclude: "Third party fee:",
    otherExpenses: "Other Fee:",
    year: "Year",
    service: "Customers who wish to choose services flexibly.",
    select: "Select a service",
    custom: "Customize - Incorporation",
    customTransfer: "Customize - Service Transfer",
    createApplication: "Create application",
    total: "Total: ",
    warn: "(Kindly reminded that our provision of services for the nominee director and/or the company registered address must be provided together with the company secretarial service.)",
    copySource: "Copy from",
    copySourceExplain:
      "To save your time, if the applicant has applied for the company/fund through this system, you can select the company/fund name through this option, so that the company/fund-related information in this system will be copies to this application.",
    operatingType: "Operation type",
    renewService: "Renew",
    increaseService: "Supplemental",
    other: "New",
    entityType: "Entity type",
    promotion: "Promotion code",
  },
};
